import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import { Collapse } from "reactstrap";

// Import Data
import navdata from "../LayoutMenuData";
//i18n
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

const VerticalLayout = (props: any) => {
  const navData = navdata().props.children;
  const location = useLocation();
  const disableParentClickForSubItems =
    props.disableParentClickForSubItems || false;

  /*
 layout settings
 */
  const selectLayoutState = (state: any) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      leftsidbarSizeType: layout.leftsidbarSizeType,
      sidebarVisibilitytype: layout.sidebarVisibilitytype,
      layoutType: layout.layoutType,
    })
  );
  // Inside your component
  const { leftsidbarSizeType, sidebarVisibilitytype, layoutType } = useSelector(
    selectLayoutProperties
  );

  //vertical and semibox resize events
  const resizeSidebarMenu = useCallback(() => {
    var windowSize = document.documentElement.clientWidth;
    const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
    var hamburgerIcon = document.querySelector(".hamburger-icon");
    if (windowSize >= 1025) {
      if (document.documentElement.getAttribute("data-layout") === "vertical") {
        document.documentElement.setAttribute(
          "data-sidebar-size",
          leftsidbarSizeType
        );
      }
      if (document.documentElement.getAttribute("data-layout") === "semibox") {
        document.documentElement.setAttribute(
          "data-sidebar-size",
          leftsidbarSizeType
        );
      }
      if (
        (sidebarVisibilitytype === "show" ||
          layoutType === "vertical" ||
          layoutType === "twocolumn") &&
        document.querySelector(".hamburger-icon")
      ) {
        if (hamburgerIcon !== null) {
          hamburgerIcon.classList.remove("open");
        }
      } else {
        // var hamburgerIcon = document.querySelector(".hamburger-icon");
        if (hamburgerIcon !== null) {
          hamburgerIcon.classList.add("open");
        }
      }
    } else if (windowSize < 1025 && windowSize > 767) {
      document.body.classList.remove("twocolumn-panel");
      if (document.documentElement.getAttribute("data-layout") === "vertical") {
        document.documentElement.setAttribute("data-sidebar-size", "sm");
      }
      if (document.documentElement.getAttribute("data-layout") === "semibox") {
        document.documentElement.setAttribute("data-sidebar-size", "sm");
      }
      if (humberIcon) {
        humberIcon.classList.add("open");
      }
    } else if (windowSize <= 767) {
      document.body.classList.remove("vertical-sidebar-enable");
      if (
        document.documentElement.getAttribute("data-layout") !== "horizontal"
      ) {
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
      if (humberIcon) {
        humberIcon.classList.add("open");
      }
    }
  }, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);

  useEffect(() => {
    window.addEventListener("resize", resizeSidebarMenu, true);
  }, [resizeSidebarMenu]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const initMenu = () => {
      const pathName = props.router.location.pathname;
      const currentPath = props.router.location.pathname;
      const activeMenuFromStorage = localStorage.getItem("activeMenu");
      const ul: any = document.getElementById("navbar-nav");
      const items = ul.getElementsByTagName("a");
      let itemsArray = [...items]; // converts NodeList to Array
      removeActivation(itemsArray);

      // Try exact match first
      let matchingMenuItem = itemsArray.find((x) => {
        return x.pathname === pathName;
      });

      // If no exact match, try partial match for nested routes
      if (!matchingMenuItem) {
        matchingMenuItem = itemsArray.find((x) => {
          const linkPath = x.pathname;

          // Handle builder-related routes with comprehensive matching
          if (
            (currentPath.startsWith("/builder") ||
              currentPath.includes("/builder-detail") ||
              (currentPath.includes("/listing-detail") &&
                activeMenuFromStorage === "builder")) &&
            linkPath === "/builder"
          )
            return true;

          // Handle properties-related routes with comprehensive matching
          if (
            (currentPath.startsWith("/properties") ||
              currentPath.includes("/properties-listing-detail") ||
              (currentPath.includes("/listing-detail") &&
                activeMenuFromStorage === "properties")) &&
            linkPath === "/properties"
          )
            return true;

          // Handle inspector-related routes with comprehensive matching
          if (
            (currentPath.startsWith("/inspector") ||
              currentPath.includes("/inspector-details")) &&
            linkPath === "/inspector"
          )
            return true;

          return false;
        });
      }

      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    if (props.layoutType === "vertical") {
      initMenu();
    }
  }, [props.router.location.pathname, props.layoutType]);

  useEffect(() => {
    // Function to update sidebar based on current state
    const updateSidebarActiveState = () => {
      const activeMenuFromStorage = localStorage.getItem("activeMenu");

      // Get all sidebar links
      const builderLink = document.getElementById("sidebar-builder-link");
      const propertiesLink = document.getElementById("sidebar-properties-link");
      const usersLink = document.getElementById("sidebar-users-link");
      const inspectorLink = document.getElementById("sidebar-inspector-link");
      const revenueLink = document.getElementById("sidebar-revenue-link");
      const refundsLink = document.getElementById("sidebar-refunds-link");
      const configurationsLink = document.getElementById(
        "sidebar-configurations-link"
      );

      // Remove active class from all links first
      [
        builderLink,
        propertiesLink,
        usersLink,
        inspectorLink,
        revenueLink,
        refundsLink,
        configurationsLink,
      ].forEach((link) => {
        if (link) link.classList.remove("active");
      });

      // Builder sidebar highlight logic
      const isBuilderPath =
        location.pathname.startsWith("/builder") ||
        location.pathname.includes("/builder-detail") ||
        (location.pathname.includes("/listing-detail") &&
          activeMenuFromStorage === "builder");

      if (builderLink && isBuilderPath) {
        if (!disableParentClickForSubItems) {
          builderLink.classList.add("active");
        }
      }

      // Properties sidebar highlight logic
      const isPropertiesPath =
        location.pathname.startsWith("/properties") ||
        location.pathname.includes("/properties-listing-detail") ||
        (location.pathname.includes("/listing-detail") &&
          activeMenuFromStorage === "properties");

      if (propertiesLink && isPropertiesPath) {
        if (!disableParentClickForSubItems) {
          propertiesLink.classList.add("active");
        }
      }

      // Users sidebar highlight logic
      const userPaths = ["/users", "/user-details"];
      if (usersLink && userPaths.includes(location.pathname)) {
        usersLink.classList.add("active");
      }

      // Inspector sidebar highlight logic
      const isInspectorPath =
        location.pathname.startsWith("/inspector") ||
        location.pathname.includes("/inspector-details");
      if (inspectorLink && isInspectorPath) {
        inspectorLink.classList.add("active");
      }

      // Revenue sidebar highlight logic - only for /revenue path
      if (revenueLink && location.pathname === "/revenue") {
        revenueLink.classList.add("active");
      }

      // Refunds sidebar highlight logic - separate handling
      if (refundsLink && location.pathname === "/refunds") {
        refundsLink.classList.add("active");
      }

      // Configurations sidebar highlight logic
      if (configurationsLink && location.pathname === "/configurations") {
        configurationsLink.classList.add("active");
      }
    };

    // Update immediately
    updateSidebarActiveState();

    // Also update after a small delay to handle async localStorage updates
    const timeoutId = setTimeout(updateSidebarActiveState, 100);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [location.pathname]);

  // Additional effect to listen for localStorage changes
  useEffect(() => {
    let lastActiveMenu = localStorage.getItem("activeMenu");

    const checkForStorageChanges = () => {
      const currentActiveMenu = localStorage.getItem("activeMenu");
      if (currentActiveMenu !== lastActiveMenu) {
        lastActiveMenu = currentActiveMenu;

        // Re-trigger the sidebar update
        const event = new CustomEvent("sidebarUpdate");
        window.dispatchEvent(event);
      }
    };

    // Poll for localStorage changes every 50ms (more frequent)
    const interval = setInterval(checkForStorageChanges, 50);

    // Listen for custom sidebar update events
    const handleSidebarUpdate = () => {
      // Trigger location change to re-run the main useEffect
      const currentPath = location.pathname;
      // Force re-evaluation by creating a new location object
      setTimeout(() => {
        const activeMenuFromStorage = localStorage.getItem("activeMenu");

        // Manually update sidebar
        const builderLink = document.getElementById("sidebar-builder-link");
        const propertiesLink = document.getElementById(
          "sidebar-properties-link"
        );

        if (builderLink) builderLink.classList.remove("active");
        if (propertiesLink) propertiesLink.classList.remove("active");

        if (currentPath.includes("/listing-detail")) {
          if (activeMenuFromStorage === "builder" && builderLink) {
            if (!disableParentClickForSubItems)
              builderLink.classList.add("active");
          } else if (activeMenuFromStorage === "properties" && propertiesLink) {
            if (!disableParentClickForSubItems)
              propertiesLink.classList.add("active");
          }
        }
      }, 10);
    };

    window.addEventListener("sidebarUpdate", handleSidebarUpdate);

    return () => {
      clearInterval(interval);
      window.removeEventListener("sidebarUpdate", handleSidebarUpdate);
    };
  }, [location.pathname]);

  function activateParentDropdown(item: any) {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv.classList.add("show");
      if (!disableParentClickForSubItems) {
        parentCollapseDiv.parentElement.children[0].classList.add("active");
        parentCollapseDiv.parentElement.children[0].setAttribute(
          "aria-expanded",
          "true"
        );
      }
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement
          .closest(".collapse")
          .classList.add("show");
        if (
          parentCollapseDiv.parentElement.closest(".collapse")
            .previousElementSibling
        ) {
          if (!disableParentClickForSubItems) {
            parentCollapseDiv.parentElement
              .closest(".collapse")
              .previousElementSibling.classList.add("active");
          }
        }
        if (
          parentCollapseDiv.parentElement
            .closest(".collapse")
            .previousElementSibling.closest(".collapse")
        ) {
          parentCollapseDiv.parentElement
            .closest(".collapse")
            .previousElementSibling.closest(".collapse")
            .classList.add("show");
          if (!disableParentClickForSubItems) {
            parentCollapseDiv.parentElement
              .closest(".collapse")
              .previousElementSibling.closest(".collapse")
              .previousElementSibling.classList.add("active");
          }
        }
      }
      return false;
    }
    return false;
  }

  const removeActivation = (items: any) => {
    let actiItems = items.filter((x: any) => x.classList.contains("active"));

    actiItems.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  };

  console.log("items", navData);

  return (
    <React.Fragment>
      <style>{`.navbar-menu .nav-sm .nav-link::before{display:none !important;} .navbar-menu .nav-sm .nav-link{color:#ffffff !important; font-size:1.1rem !important;} .nav-link.disabled{ color:#B5B3B3 !important; cursor:not-allowed; pointer-events:none; opacity:0.65; } .nav-link.disabled i{ opacity:0.65; color:inherit !important; } .nav-link.disabled .text-white, .nav-link.disabled .fs-5{ color:#6c757d !important; opacity:0.65; }`}</style>
      {/* menu Items */}
      {(navData || []).map((item: any, key: number) => {
        const isDisabled = !!item.disabled;
        // Identify the Builder link
        const isBuilder = item.link && item.link.includes("/builder");
        // Identify the Users link
        const isUsers = item.link && item.link === "/users";
        // Identify the Inspector link
        const isInspector = item.link && item.link === "/inspector";
        // Identify the Properties link
        const isProperties = item.link && item.link === "/properties";
        // Identify the Revenue link
        const isRevenue = item.link && item.link === "/revenue";
        // Identify the Refunds link
        const isRefunds = item.link && item.link === "/refunds";
        // Identify the Configurations link
        const isConfigurations = item.link && item.link === "/configurations";
        return (
          <React.Fragment key={key}>
            {/* Main Header */}
            {item["isHeader"] ? (
              <li className="menu-title">
                <span data-key="t-menu" className="text-white">
                  {props.t(item.label)}
                </span>
              </li>
            ) : item.subItems ? (
              <li className="nav-item">
                <Link
                  id={
                    isBuilder
                      ? "sidebar-builder-link"
                      : isUsers
                      ? "sidebar-users-link"
                      : isInspector
                      ? "sidebar-inspector-link"
                      : isProperties
                      ? "sidebar-properties-link"
                      : isRevenue
                      ? "sidebar-revenue-link"
                      : isRefunds
                      ? "sidebar-refunds-link"
                      : isConfigurations
                      ? "sidebar-configurations-link"
                      : undefined
                  }
                  onClick={
                    isDisabled
                      ? (e: any) => e.preventDefault()
                      : disableParentClickForSubItems && item.subItems
                      ? (e: any) => e.preventDefault()
                      : item.link
                      ? undefined
                      : item.click
                  }
                  className={
                    "nav-link menu-link" + (isDisabled ? " disabled" : "")
                  }
                  to={
                    isDisabled
                      ? "/#"
                      : disableParentClickForSubItems && item.subItems
                      ? "/#"
                      : item.link
                      ? item.link
                      : "/#"
                  }
                  aria-disabled={isDisabled}
                  tabIndex={isDisabled ? -1 : undefined}
                  // data-bs-toggle={
                  //   !disableParentClickForSubItems ? "collapse" : undefined
                  // }
                >
                  {typeof item.icon === "string" ? (
                    <i className={item.icon}></i>
                  ) : (
                    item.icon
                  )}
                  <span data-key="t-apps" className="text-white">
                    {props.t(item.label)}
                  </span>
                </Link>
                <Collapse
                  className="menu-dropdown"
                  isOpen={true}
                  id="sidebarApps"
                >
                  <ul className="nav nav-sm flex-column test">
                    {item.subItems &&
                      (item.subItems || []).map((subItem: any, key: number) => {
                        const isSubDisabled = !!subItem.disabled;
                        return (
                          <React.Fragment key={key}>
                            {!subItem.isChildItem ? (
                              <li className="nav-item">
                                <Link
                                  to={
                                    isSubDisabled
                                      ? "/#"
                                      : subItem.link
                                      ? subItem.link
                                      : "/#"
                                  }
                                  className={
                                    "nav-link text-white" +
                                    (isSubDisabled ? " disabled" : "")
                                  }
                                  onClick={
                                    isSubDisabled
                                      ? (e: any) => e.preventDefault()
                                      : subItem.link
                                      ? undefined
                                      : subItem.click
                                  }
                                  aria-disabled={isSubDisabled}
                                  tabIndex={isSubDisabled ? -1 : undefined}
                                >
                                  {props.t(subItem.label)}
                                  {subItem.badgeName ? (
                                    <span
                                      className={
                                        "badge badge-pill bg-" +
                                        subItem.badgeColor
                                      }
                                      data-key="t-new"
                                    >
                                      {subItem.badgeName}
                                    </span>
                                  ) : null}
                                </Link>
                              </li>
                            ) : (
                              <li className="nav-item">
                                <Link
                                  onClick={
                                    isSubDisabled
                                      ? (e: any) => e.preventDefault()
                                      : disableParentClickForSubItems
                                      ? (e: any) => e.preventDefault()
                                      : subItem.link
                                      ? undefined
                                      : subItem.click
                                  }
                                  className={
                                    "nav-link" +
                                    (isSubDisabled ? " disabled" : "")
                                  }
                                  to={
                                    isSubDisabled
                                      ? "/#"
                                      : disableParentClickForSubItems
                                      ? "/#"
                                      : "/#"
                                  }
                                  data-bs-toggle={
                                    !disableParentClickForSubItems
                                      ? "collapse"
                                      : undefined
                                  }
                                  aria-disabled={isSubDisabled}
                                  tabIndex={isSubDisabled ? -1 : undefined}
                                >
                                  {props.t(subItem.label)}
                                  {subItem.badgeName ? (
                                    <span
                                      className={
                                        "badge badge-pill bg-" +
                                        subItem.badgeColor
                                      }
                                      data-key="t-new"
                                    >
                                      {subItem.badgeName}
                                    </span>
                                  ) : null}
                                </Link>
                                <Collapse
                                  className="menu-dropdown"
                                  isOpen={
                                    disableParentClickForSubItems
                                      ? true
                                      : subItem.stateVariables
                                  }
                                  id="sidebarEcommerce"
                                >
                                  <ul className="nav nav-sm flex-column">
                                    {/* child subItms  */}
                                    {subItem.childItems &&
                                      (subItem.childItems || []).map(
                                        (childItem: any, key: number) => {
                                          const isChildDisabled =
                                            !!childItem.disabled;
                                          return (
                                            <React.Fragment key={key}>
                                              {!childItem.childItems ? (
                                                <li className="nav-item">
                                                  <Link
                                                    to={
                                                      isChildDisabled
                                                        ? "/#"
                                                        : childItem.link
                                                        ? childItem.link
                                                        : "/#"
                                                    }
                                                    className={
                                                      "nav-link fs-5" +
                                                      (isChildDisabled
                                                        ? " disabled"
                                                        : "")
                                                    }
                                                    onClick={
                                                      isChildDisabled
                                                        ? (e: any) =>
                                                            e.preventDefault()
                                                        : undefined
                                                    }
                                                    aria-disabled={
                                                      isChildDisabled
                                                    }
                                                    tabIndex={
                                                      isChildDisabled
                                                        ? -1
                                                        : undefined
                                                    }
                                                  >
                                                    {props.t(childItem.label)}
                                                  </Link>
                                                </li>
                                              ) : (
                                                <li className="nav-item">
                                                  <Link
                                                    to="/#"
                                                    className={
                                                      "nav-link fs-5" +
                                                      (isChildDisabled
                                                        ? " disabled"
                                                        : "")
                                                    }
                                                    onClick={
                                                      isChildDisabled
                                                        ? (e: any) =>
                                                            e.preventDefault()
                                                        : disableParentClickForSubItems
                                                        ? (e: any) =>
                                                            e.preventDefault()
                                                        : childItem.link
                                                        ? undefined
                                                        : childItem.click
                                                    }
                                                    data-bs-toggle={
                                                      !disableParentClickForSubItems
                                                        ? "collapse"
                                                        : undefined
                                                    }
                                                    aria-disabled={
                                                      isChildDisabled
                                                    }
                                                    tabIndex={
                                                      isChildDisabled
                                                        ? -1
                                                        : undefined
                                                    }
                                                  >
                                                    {props.t(childItem.label)}
                                                  </Link>
                                                  <Collapse
                                                    className="menu-dropdown"
                                                    isOpen={
                                                      disableParentClickForSubItems
                                                        ? true
                                                        : childItem.stateVariables
                                                    }
                                                    id="sidebaremailTemplates"
                                                  >
                                                    <ul className="nav nav-sm flex-column">
                                                      {childItem.childItems.map(
                                                        (
                                                          subChildItem: any,
                                                          key: number
                                                        ) => (
                                                          <li
                                                            className="nav-item"
                                                            key={key}
                                                          >
                                                            <Link
                                                              to={
                                                                subChildItem.link
                                                              }
                                                              className={
                                                                "nav-link" +
                                                                (subChildItem.disabled
                                                                  ? " disabled"
                                                                  : "")
                                                              }
                                                              onClick={
                                                                subChildItem.disabled
                                                                  ? (e: any) =>
                                                                      e.preventDefault()
                                                                  : undefined
                                                              }
                                                              data-key="t-basic-action"
                                                              aria-disabled={
                                                                subChildItem.disabled
                                                              }
                                                              tabIndex={
                                                                subChildItem.disabled
                                                                  ? -1
                                                                  : undefined
                                                              }
                                                            >
                                                              {props.t(
                                                                subChildItem.label
                                                              )}{" "}
                                                            </Link>
                                                          </li>
                                                        )
                                                      )}
                                                    </ul>
                                                  </Collapse>
                                                </li>
                                              )}
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                  </ul>
                                </Collapse>
                              </li>
                            )}
                          </React.Fragment>
                        );
                      })}
                  </ul>
                </Collapse>
              </li>
            ) : (
              <li className="nav-item">
                <Link
                  id={
                    isBuilder
                      ? "sidebar-builder-link"
                      : isUsers
                      ? "sidebar-users-link"
                      : isInspector
                      ? "sidebar-inspector-link"
                      : isProperties
                      ? "sidebar-properties-link"
                      : isRevenue
                      ? "sidebar-revenue-link"
                      : isRefunds
                      ? "sidebar-refunds-link"
                      : isConfigurations
                      ? "sidebar-configurations-link"
                      : undefined
                  }
                  onClick={
                    isDisabled ? (e: any) => e.preventDefault() : undefined
                  }
                  className={
                    "nav-link menu-link" + (isDisabled ? " disabled" : "")
                  }
                  to={isDisabled ? "/#" : item.link ? item.link : "/#"}
                  aria-disabled={isDisabled}
                  tabIndex={isDisabled ? -1 : undefined}
                >
                  {typeof item.icon === "string" ? (
                    <i className={item.icon}></i>
                  ) : (
                    item.icon
                  )}
                  <span className="text-white fs-5">{props.t(item.label)}</span>
                </Link>
              </li>
            )}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

VerticalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  disableParentClickForSubItems: PropTypes.bool,
};

export default withRouter(withTranslation()(VerticalLayout));
